// deepsageReasoningUtils.js

export const enqueueDeepsageReasoningRequest = async (GID, CID, IDD, query, token) => {
    console.log(GID, CID, IDD, query, token);
    const payload = {
        serviceName: "ENQUEUE_DEEPSAGE_REASONING",
        GID: GID,
        CID: CID,
        IDD: IDD,
        Query: query,
        Token: token
    };

    const response = await fetch("https://deep-sage.softmining.it/chat.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
    });
    const data = await response.json();
    return data;
};

export const checkDeepsageReasoningStatus = async (GID, CID, IDD, query, token) => {
    const payload = {
        serviceName: "DEEPSAGE_REASONING_REQUEST_STATUS",
        GID: GID,
        CID: CID,
        IDD: IDD,
        Query: query,
        Token: token
    };

    const response = await fetch("https://deep-sage.softmining.it/chat.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
    });
    const data = await response.json();
    return data;
};

export const getDeepsageReasoningOutput = async (GID, CID, IDD, query, token) => {
    const payload = {
        serviceName: "GET_DEEPSAGE_REASONING_OUTPUT",
        GID: GID,
        CID: CID,
        IDD: IDD,
        Query: query,
        Token: token
    };

    const response = await fetch("https://deep-sage.softmining.it/chat.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
    });
    const data = await response.json();
    return data;
};
